import { useState } from "react";
import { postGiftPaymentLink } from "@local/services/webApi";
import { AMOUNT_DECIMAL_OFFSET } from "../services/constants";
import { useCancelPromise } from "@Utilities/services/hooks";
import { logComponentEvent } from '@Utilities/services/logging/componentEvent';

export const useGiftReview = ({
  selectedGiftAmount,
  checkoutMessage,
  relationship,
  setAlertProps,
  validateRelationshipForm,
  validateDetailsForm,
  locale,
  selectedOccasion
}) => {
  const [isPaymentLoading, setIsPaymentLoading] = useState();
  const cancelPromise = useCancelPromise();

  // Calculates Stripe unit amount format for pricing
  const calculateStripeGiftAmount = (value) => Math.round(value * AMOUNT_DECIMAL_OFFSET);

  // Checkout after validation
  const submitCheckout = () => {
    logComponentEvent('GiftingReview', 'CtaClicked');

    const { isAmountValid, isMessageValid } = validateDetailsForm(selectedGiftAmount, checkoutMessage);
    const { isRelationshipValid } = validateRelationshipForm(relationship);

    if (!isAmountValid || !isMessageValid || !isRelationshipValid) {
      return setAlertProps({
        severity: 'error',
        message: 'giftDetails.error.allFieldsRequired'
      });
    }

    setAlertProps({});
    setIsPaymentLoading(true);
    postGiftPaymentLink({
      price: calculateStripeGiftAmount(selectedGiftAmount),
      relationship,
      message: checkoutMessage,
      locale,
      ...selectedOccasion ? { occasion: selectedOccasion.value } : {}
    })
      .then((response) => {
        if (!cancelPromise.current) {
          const { stripeUrl } = response?.data || {};

          if (stripeUrl) {
            window.location.href = stripeUrl;
          } else {
           setAlertProps({
              severity: 'error',
              message: 'networkError.title'
            });
          }
        }
      })
      .catch(() => {
        if (!cancelPromise.current) {
          setAlertProps({
            severity: 'error',
            message: 'networkError.title'
          });
        }
      })
      .finally(() => {
        if (!cancelPromise.current) {
          setIsPaymentLoading(false);
        }
      });
  };

  return {
    submitCheckout,
    isPaymentLoading
  };
};
